import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postData,
  getData,
  patchData,
} from "../../../../services/apiEndpoints";
import { handleError } from "../../Common/Alerts/errorhandling.action";
import { setShowError } from "../../Common/Alerts/alertsSlice";

const BASE_URL = "/job-application";

export const applyToJobThunk = createAsyncThunk(
  "jobApplication/applyToJob",
  async ({ schoolId, jobId, formData }, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));

      const response = await postData(
        `${BASE_URL}/apply/${schoolId}/${jobId}`,
        { formData },
      );

      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);

export const getApplicationsThunk = createAsyncThunk(
  "jobApplication/getApplications",
  async (queryParams, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));

      const response = await getData(`${BASE_URL}/getall`, queryParams);

      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);

export const getSingleApplicationThunk = createAsyncThunk(
  "jobApplication/getSingleApplication",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));

      const response = await getData(`${BASE_URL}/getbyid/${id}`);

      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);

export const scheduleInterviewThunk = createAsyncThunk(
  "jobApplication/scheduleInterview",
  async (
    { applicationId, roundId, interviewData },
    { rejectWithValue, dispatch }
  ) => {
    try {
      dispatch(setShowError(false));

      const response = await postData(
        `${BASE_URL}/interview/${applicationId}/${roundId}`,
        interviewData
      );
      if (!response?.success) {
        return rejectWithValue(response?.message || "Failed to schedule interview");
      }

      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

export const evaluateRoundThunk = createAsyncThunk(
  "jobApplication/evaluateRound",
  async ({ id, payload }, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));

      const response = await patchData(`${BASE_URL}/${id}/evaluate`, payload);

      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);

export const moveToNextRoundThunk = createAsyncThunk(
  "jobApplication/moveToNextRound",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));

      const response = await patchData(`${BASE_URL}/${id}/next-round`);

      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);

export const assignHRThunk = createAsyncThunk(
  "jobApplication/assignHR",
  async ({ id, staffId }, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));

      const response = await patchData(`${BASE_URL}/${id}/assign-hr`, {
        staffId,
      });

      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);

export const rejectCandidateThunk = createAsyncThunk(
  "jobApplication/rejectCandidate",
  async (
    { id, performanceSummary, overallStatus, isRejected },
    { rejectWithValue, dispatch },
  ) => {
    try {
      dispatch(setShowError(false));

      const payload = {
        performanceSummary,
        overallStatus,
        isRejected,
      };

      const response = await patchData(
        `${BASE_URL}/${id}/reject-applicant`,
        payload,
      );

      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);

export const getInterviewsbyStaffThunk = createAsyncThunk(
  "jobApplication/getInterviewsbyStaff",
  async (filters, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));

      const params = new URLSearchParams(filters).toString();
      const response = await getData(
        `${BASE_URL}/get-interview-by-staff?${params}`,
      );

      return response.data;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);

export const updateInterviewsbyStaffThunk = createAsyncThunk(
  "jobApplication/updateInterviewsbyStaff",
  async (
    { applicationId, interviewId, data },
    { rejectWithValue, dispatch },
  ) => {
    try {
      dispatch(setShowError(false));

      const response = await patchData(
        `${BASE_URL}/update-interview-by-staff/${applicationId}/${interviewId}`,
        data,
      );

      return response?.data;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  },
);

export const updateRoundCommunicationThunk = createAsyncThunk(
  "jobApplication/updateRoundCommunication",
  async ({ applicationId, roundId, type }, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));

      const response = await patchData(
        `${BASE_URL}/communication/${applicationId}/${roundId}`,
        { type }
      );

      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);


export const moveMultipleApplicantsToNextRoundThunk = createAsyncThunk(
  "jobApplication/moveMultipleApplicantsToNextRound",
  async (applicationIds, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));

      const response = await postData(
        `${BASE_URL}/applications/move-next-round/bulk`,
        { applicationIds }
      );

      return response;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);
